import * as React from 'react';
import { useDispatch } from 'react-redux';

import { closeOfferPreview } from '../../../../common/actions/closeOfferPreview/closeOfferPreview';
import { TThunkDispatch } from '../../../../common/types/redux';

export function useCloseOfferPreviewOnMapClick(map: YMaps.Map): void {
  const dispatch = useDispatch<TThunkDispatch>();

  React.useEffect(() => {
    const handleMapClick = () => {
      dispatch(closeOfferPreview());
    };

    map.events.add('click', handleMapClick);

    return () => {
      map.events.remove('click', handleMapClick);
    };
  }, [dispatch, map]);
}
